import { each } from '../util'

export const AssesmentManager = {
  containers: document.querySelectorAll('.js-assesment-accordion'),
  instances: [],

  initInstances: function () {
    this.instances.forEach(_ => {
      if (_.panel && _.panel.getAttribute('data-disabled')) {
        _.textEl.classList.add('is-visible')
        _.textDate.innerText = _.panel.getAttribute('data-disabled')
        _.input.setAttribute('disabled', '')
        _.submitButton.setAttribute('disabled', '')
      }
    })
  },

  init: function () {
    if (this.containers && this.containers.length > 0) {
      each(this.containers, (_i, container) => {
        const panels = container.querySelectorAll('.js-badger-accordion-panel')
        panels.forEach(panel => {
          const textEl = panel.querySelector('.js-assesment-text')
          const textDate = panel.querySelector('.js-assesment-text-date')
          const form = panel.querySelector('.js-assesment-form')
          const input = panel.querySelector('.js-assesment-input')
          const submitButton = panel.querySelector('.js-assesment-submit')

          this.instances.push({
            panel,
            textEl,
            textDate,
            form,
            input,
            submitButton
          })
        })
      })

      this.initInstances()
    }
  }
}



// WEBPACK FOOTER //
// app/javascript/scripts/components/AssesmentManager.js